module.exports = __webpack_public_path__ + "img/lg_ring_g_c_1_1.002d5ad3.png";